import {Component, OnInit} from '@angular/core';
import {EnvService} from "../../services/env.service";
import {HttpClient} from "@angular/common/http";
import {ActivatedRoute, Router, Params} from '@angular/router';
import {AlertService} from "../../services/alert.service";
import {AuthService} from "../../services/auth.service";

@Component({
  selector: 'micro-mail2SmsMailbox-detail',
  templateUrl: './mail2SmsMailbox-detail.component.html'
})
export class Mail2SmsMailboxDetailComponent implements OnInit {
  mail2SmsMailbox:any;

  constructor(private env: EnvService,
              private http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              public authService:AuthService,
              private alertService:AlertService) {
  }

  public ngOnInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/mail2sms/mail2SmsMailboxes/${id}`).subscribe(
            data => {
              this.setMail2SmsMailbox(data)
            }
          );
        }
      });
  }

  setMail2SmsMailbox(mail2SmsMailbox:any) {
    this.mail2SmsMailbox = mail2SmsMailbox;
  }

  createNew() {
    this.mail2SmsMailbox = {
      enabled: true,
      recipientAddressFilter: '.*\\.*msg.taulite.co.za',
      messagingChannel: 'SMS',
    };
  }

  save() {
    if (!this.mail2SmsMailbox.id) {
      this.http.post(`${this.env.e.url}/mail2sms/mail2SmsMailboxes`, this.mail2SmsMailbox)
        .subscribe(
          data => {
            this.setMail2SmsMailbox(data)
            this.alertService.info(`Created ${this.mail2SmsMailbox.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/mail2sms/mail2SmsMailboxes/${this.mail2SmsMailbox.id}`, this.mail2SmsMailbox)
        .subscribe(
          data => {
            this.setMail2SmsMailbox(data)
            this.alertService.info(`Updated`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/mail2sms/mail2SmsMailboxes/${this.mail2SmsMailbox.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.mail2SmsMailbox.name}`);
          this.router.navigate(["/mail2msg/mailboxes"]);
        }
      );
  }
}
